import { render, staticRenderFns } from "./ManifestImport.vue?vue&type=template&id=34cc488c"
import script from "./ManifestImport.vue?vue&type=script&lang=js"
export * from "./ManifestImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports